import React from 'react';
import SectionHeader from './ui/SectionHeader';

const MODES = [
  { emoji: '☕', title: 'Open to chat', desc: 'Low pressure—here to talk, vibe check, and see where things go.', badge: 'CHAT' },
  { emoji: '💫', title: 'Dating', desc: 'Looking for dates and something that might grow beyond the app.', badge: 'DATE' },
  { emoji: '🤝', title: 'Friends first', desc: 'Community and friendship; romance optional.', badge: 'FRIENDS' },
  { emoji: '⚡', title: 'Tonight / soon', desc: 'Free in the next hours or day—open to meeting if the fit is right.', badge: 'SOON' },
  { emoji: '🏠', title: 'Taking it slow', desc: 'On the app on my own timeline; not in a rush to meet.', badge: 'SLOW' },
  { emoji: '👀', title: 'Just looking', desc: 'Browsing profiles and getting a feel for the community.', badge: 'BROWSE' },
];

const DURATIONS = [
  { time: '2 hours', desc: 'Short visibility burst' },
  { time: '6 hours', desc: 'Same-day window' },
  { time: '24 hours', desc: 'Full day on the grid' },
  { time: '3 days', desc: 'Longer discovery run' },
];

function DiscoveryModes() {
  return (
    <section id="modes" className="relative overflow-hidden bg-onyx py-24 md:py-32">
      <div className="pointer-events-none absolute right-0 top-1/4 h-72 w-72 rounded-full bg-secondary/10 blur-[90px]" aria-hidden />

      <div className="site-container relative">
        <div className="grid items-start gap-10 lg:grid-cols-[1fr_1.4fr] lg:gap-14">
          <div className="lg:sticky lg:top-28">
            <SectionHeader
              tag="When you’re ready"
              title="Show up"
              titleAccent="your way"
              description="Once you feel safe, choose how you want to connect — from low-pressure chat to dating. You control how long you’re visible, and you can change or hide anytime."
              align="left"
            />

            <div className="glass-card p-6">
              <p className="mb-4 text-xs font-bold uppercase tracking-widest text-silver">Visibility Duration</p>
              <div className="space-y-3">
                {DURATIONS.map((dur) => (
                  <div key={dur.time} className="flex items-center justify-between border-b border-white/5 py-2 last:border-0">
                    <span className="font-bold text-white">{dur.time}</span>
                    <span className="text-sm text-silver">{dur.desc}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="grid gap-3">
            {MODES.map((mode) => (
              <article key={mode.title} className="glass-card-hover grid grid-cols-[auto_1fr_auto] items-start gap-4 p-5 md:p-6">
                <span className="text-2xl">{mode.emoji}</span>
                <div>
                  <h3 className="mb-1 font-bold text-white">{mode.title}</h3>
                  <p className="text-sm leading-relaxed text-silver">{mode.desc}</p>
                </div>
                <span className="rounded-full border border-primary/25 bg-primary/10 px-3 py-1 text-[0.65rem] font-bold text-primary">
                  {mode.badge}
                </span>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default DiscoveryModes;
